import { ReactNode } from 'react';
import { PortalHeader } from '../portal/PortalHeader';

interface AdminShellProps {
    children: ReactNode;
}

export function AdminShell({ children }: AdminShellProps) {
    return (
        <div className="min-h-screen bg-admin-app">
            <PortalHeader />
            <main className="mx-auto w-full max-w-7xl px-6 py-8">{children}</main>
        </div>
    );
}
